import { OPEN_LAYER, CLOSE_LAYER } from '../constants/layer';
import { showChatIcon } from '../actions/chatIcon';
/**
 * Middleware for showing / hiding chat icon based on layer action types
 * @returns {Function}
 */
export default function chatIconMiddleware() {
  return ({ dispatch }) => next => action => {
    const result = next(action);
    switch (action.type) {
      case OPEN_LAYER:
        if (
          action.payload === 'bag' ||
          action.payload === 'myAccount' ||
          action.payload === 'search' ||
          action.payload === 'shop'
        ) {
          dispatch(showChatIcon(false));
        }
        break;
      case CLOSE_LAYER:
        dispatch(showChatIcon(true));
        break;
      default:
        break;
    }
    return result;
  };
}
